import { BOUserRoles } from 'models'

export const rolesString: { [key: string]: string } = {
  [BOUserRoles.BO_SUPER_ADMIN]: 'Back Office Super Admin',
  [BOUserRoles.BO_ADMIN_COMPLIANCE]: 'Back Office Admin Compliance',
  [BOUserRoles.BO_ADMIN_FINANCE]: 'Back Office Admin Finance',
  [BOUserRoles.BO_ADMIN_OPERATION]: 'Back Office Admin Operation',
  [BOUserRoles.BO_ADMIN_TECH]: 'Back Office Admin Tech',
  [BOUserRoles.BO_COMPLIANCE]: 'Back Office Compliance',
  [BOUserRoles.BO_FINANCE]: 'Back Office Finance',
  [BOUserRoles.BO_OPERATION]: 'Back Office Operation',
  [BOUserRoles.BO_TECH]: 'Back Office Tech',
}
